var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"page_contents"}},[_c('flavour-header'),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('flavour-branding'),_c('flavour-footer2'),_c('back-to-top-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }